/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type BriefSubmittedMutationVariables = Types.Exact<{
    requestId: Types.Scalars['ID'];
    isOverflow: Types.Scalars['Boolean'];
}>;

export type BriefSubmittedMutation = {
    __typename: 'Mutation';
    addEvent_BriefSubmitted: { __typename: 'Request'; publicId: string };
};

export const BriefSubmittedDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'BriefSubmitted' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'requestId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'isOverflow' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addEvent_BriefSubmitted' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'requestId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'requestId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'isOverflow' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'isOverflow' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type BriefSubmittedMutationFn = Apollo.MutationFunction<
    BriefSubmittedMutation,
    BriefSubmittedMutationVariables
>;

/**
 * __useBriefSubmittedMutation__
 *
 * To run a mutation, you first call `useBriefSubmittedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBriefSubmittedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [briefSubmittedMutation, { data, loading, error }] = useBriefSubmittedMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      isOverflow: // value for 'isOverflow'
 *   },
 * });
 */
export function useBriefSubmittedMutation(
    baseOptions?: Apollo.MutationHookOptions<
        BriefSubmittedMutation,
        BriefSubmittedMutationVariables
    >
) {
    return Apollo.useMutation<BriefSubmittedMutation, BriefSubmittedMutationVariables>(
        BriefSubmittedDocument,
        baseOptions
    );
}
export type BriefSubmittedMutationHookResult = ReturnType<typeof useBriefSubmittedMutation>;
export type BriefSubmittedMutationResult = Apollo.MutationResult<BriefSubmittedMutation>;
export type BriefSubmittedMutationOptions = Apollo.BaseMutationOptions<
    BriefSubmittedMutation,
    BriefSubmittedMutationVariables
>;
